import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_DEFAULT_BUTTONS, EDGE_DEFAULT_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeDefaultButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={DefaultButton} span={EDGE_DEFAULT_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn color="primary" className="btn-pill" id="Tooltip-1">{PrimaryButton}</Btn>
        <ToolTip target="Tooltip-1" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary</ToolTip>
        {EDGE_DEFAULT_BUTTONS_LIST.map((data, index) => (
          <CommonEdgeButton key={index} item={data} />
        ))}
      </CardBody>
    </Card>
  );
};

export default EdgeDefaultButtons;
